export default __webpack_public_path__ + "static/media/vascbase1.1213aad7.png";